export type TriggerErrorPayload = {
  triggerId: string;
  stepId: string | null;
  field: string;

  rootError?: boolean;
  message: string;
};

export default class TriggerErrorException extends Error {
  public data: TriggerErrorPayload;
  constructor(triggerError: TriggerErrorPayload) {
    super(JSON.stringify(triggerError.message));
    this.name = "TriggerError";
    this.data = triggerError;
  }
}
